// export const fetchOrderedCourses = async ({ BeURL, page = 1, limit = 10 }) => {
//     try {
//         const res = await fetch(
//             `${BeURL}/fetch-ordered-courses?page=${page}&limit=${limit}`,
//             { credentials: "include" }
//         );
//         const data = await res.json();

//         if (!data.success) {
//             console.error(data.message || "Failed to fetch order.");
//             return null;
//         }

//         return data;
//     } catch (err) {
//         console.error("Error fetching carts:", err);
//         return null;
//     }
// };





export const fetchOrderedCourses = async ({
    BeURL,
    page = 1,
    limit = 10,
    ...filters
}) => {
    try {
        /* 🔥 BUILD QUERY PARAMS */
        const params = new URLSearchParams({
            page,
            limit,
            ...filters
        }).toString();

        const res = await fetch(
            `${BeURL}/fetch-ordered-courses?${params}`,
            { credentials: "include" }
        );

        const data = await res.json();

        if (!data.success) {
            console.error(data.message || "Failed to fetch order.");
            return null;
        }

        return data;

    } catch (err) {
        console.error("Error fetching orders:", err);
        return null;
    }
};